// Solano Essence — i18n index.
// Language dictionaries live in ./locales/<lang>.js. This file is intentionally
// small: it just aggregates them and exports the shared LANGUAGES list.
import it from "./locales/it";
import en from "./locales/en";
import de from "./locales/de";
import fr from "./locales/fr";

export const translations = { it, en, de, fr };

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
];
